import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Gift, Loader2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { useSubscription } from "@/subscription/SubscriptionContext";
import { formatApiErrorDetail } from "@/auth/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function RedeemDialog({ open, onOpenChange }) {
  const { refresh } = useSubscription();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const redeem = async () => {
    if (!code.trim()) return toast.error("Enter a code");
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/promo/redeem`, { code: code.trim() });
      toast.success(data.message || "Pro unlocked!");
      await refresh();
      setCode("");
      onOpenChange(false);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Could not redeem code");
    }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0f0f0f] border-[#ffd166]/40 text-white max-w-sm" data-testid="redeem-dialog">
        <DialogHeader>
          <DialogTitle className="font-display tracking-widest flex items-center gap-2 text-[#ffd166]">
            <Gift size={18} /> REDEEM A CODE
          </DialogTitle>
          <DialogDescription className="text-neutral-500 text-xs">
            Got a promo code? Enter it to unlock BeatMXR Pro.
          </DialogDescription>
        </DialogHeader>
        <input
          data-testid="redeem-code-input"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          onKeyDown={(e) => e.key === "Enter" && !busy && redeem()}
          placeholder="BEATXXXXX"
          className="w-full bg-[#050505] border border-[#262626] rounded-sm px-3 py-2.5 text-sm font-mono-data text-[#ffd166] outline-none focus:border-[#ffd166]"
        />
        <button
          data-testid="redeem-submit-btn"
          onClick={redeem}
          disabled={busy}
          className="flex items-center justify-center gap-2 rounded-sm py-2.5 text-sm font-bold text-black bg-[#ffd166] disabled:opacity-50"
        >
          {busy ? <Loader2 size={15} className="animate-spin" /> : <Gift size={15} />} Redeem
        </button>
      </DialogContent>
    </Dialog>
  );
}
